const gtag = (...args) => {
    if (window.gtag) {
        window.gtag(...args);
    }
};

export const initGA = () => {
    // GA4 is initialized via the script tag in index.html
    // This function is kept for backwards compatibility
};

export const userLoggedIn = () => {
    gtag("event", "login", {
        method: "email",
    });
};

export const userLoggedOut = () => {
    gtag("event", "logout");
};

export const userSignUp = () => {
    gtag("event", "sign_up", {
        method: "email",
    });
};

export const userGoogleLogin = () => {
    gtag("event", "login", {
        method: "google",
    });
};

export const userGoogleSignUp = () => {
    gtag("event", "sign_up", {
        method: "google",
    });
};

export const userFlipCoin = () => {
    gtag("event", "flip_coin", {
        event_category: "game",
        event_label: "coin_flip",
    });
};

export const userFlipResult = (result, streakLength) => {
    gtag("event", "flip_result", {
        event_category: "game",
        result: result,
        streak_length: streakLength,
    });
};

export const userViewLeaderboard = () => {
    gtag("event", "view_leaderboard", {
        event_category: "engagement",
    });
};

export const userSetUsername = () => {
    gtag("event", "set_username", {
        event_category: "onboarding",
    });
};

export const pageView = (pageName) => {
    gtag("event", "page_view", {
        page_title: pageName,
    });
};
